export enum LiveItemStatus {
  TO_BE_STARTED = 1,
  IN_PROGRESS = 2,
  FINISHED = 3,
}
